import { VIEWERS } from "../../consts";
import getArtifactPublicIdFromResourceList from "./resourceList";
import { getCloudFromConfig } from "../../utils";

const buildUrl = async (props, config, triggerWithAnalytics) => {
	const prodId = props.id || config.defaults?.product;
	const preset = props.preset || config.defaults?.preset;
	const rType = (props.type === VIEWERS.VIDEO || props.from === "video") ? "video" : "image";
	let publicIdFromResourceList = await getArtifactPublicIdFromResourceList(config, prodId, preset, props.name, rType, triggerWithAnalytics);

	const publicId = publicIdFromResourceList ?
		//successfully retrieved publicId from resource list
		["/", publicIdFromResourceList] :
		//fall back to old way:
		[`/${prodId}`,
			`/${preset}`,
			`/${props.name}`
		];

	return [
		config.baseUrl,
		getCloudFromConfig(config),
		(props.type === VIEWERS.VIDEO || props.from === "video") ? "/video/upload" :  "/image/upload",
		(props.urlParams ? `/${props.urlParams}` : ""),
	].concat(publicId).join("");
};

export default buildUrl;
